import React, { useEffect, useState } from 'react'

import { openChat } from 'app/PylonIntegration'
import { useCanAccessSupport } from 'utils/intercom'

import { Icon, Tooltip } from 'v2/ui'

import { AppBarButton } from './AppBarButton'

type PylonChatButtonProps = {
    navTheme: { [key: string]: string }
}

/**
 * Renders the "Help & Support" chat menu item inside the app bar menu.
 * The menu item is only visible when:
 *   1. A user is logged in
 *   3. The user has the ContactSupport right
 *
 * The chat bubble is hidden on mount unless there are unread messages.
 */
export const PylonChatButton: React.FC<PylonChatButtonProps> = ({ navTheme }) => {
    const canAccessSupport = useCanAccessSupport()

    const [unread, setUnread] = useState(0)

    useEffect(() => {
        // hide when the page mounts
        //@ts-ignore
        window.Pylon?.('hideChatBubble')

        //@ts-ignore
        window.Pylon?.('onChangeUnreadMessagesCount', (n: number) => {
            setUnread(n)
        })

        // When the user closes the chat, hide the chat bubble
        //@ts-ignore
        window.Pylon?.('onHide', () => {
            //@ts-ignore
            window.Pylon?.('hideChatBubble')
        })
    }, [])

    if (!canAccessSupport) return null

    return (
        <Tooltip label="Help & Support">
            <AppBarButton
                wrap="nowrap"
                navTheme={navTheme}
                aria-label="Open support chat"
                onClick={openChat}
                style={{
                    border: 'none',
                    boxShadow: 'none',
                }}
            >
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <Icon icon="questionCircle" size="22px" />
                    {unread > 0 && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '-5px',
                                right: '-5px',
                                minWidth: '12px',
                                height: '12px',
                                borderRadius: '9px',
                                backgroundColor: '#E53E3E',
                                border: 'none',
                                zIndex: 10,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0 4px',
                                fontSize: '8px',
                                fontWeight: 'bold',
                                color: 'white',
                                lineHeight: '1',
                            }}
                        >
                            {unread > 99 ? '99+' : unread}
                        </div>
                    )}
                </div>
            </AppBarButton>
        </Tooltip>
    )
}
